import { Component } from '@angular/core';
import { CacheService } from '../../../../cache/cache.service';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../../models/workflow/workflow.model';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { ARedisSettings } from './addtoredis.settings';

export class GetFromRedisSettingsData {
    Key = '';
}

export class GetFromRedisSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getEmptySettingsInstance() {
        return new GetFromRedisSettingsData();
    }

    getExitPoints(settings): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
}

export class GetFromRedisModuleExecuter extends WorkflowModuleExecuter {
    async execute(status: WorkflowStatus): Promise<number> {
        if (status.ActualSettings) {
            status.ActualParameter = await CacheService.GetFromWorkflowCache(status.ActualSettings.Key);
            return 0;
        } else {
            status.Logger.logError('Add to cache modul: No settings found.');
        }
        return super.execute(status);
    }
}

@Component({
    selector: 'wf-getfromredis-settings',
    templateUrl: 'redis.settings.html'
})
export class GetFromRedisSettings extends ARedisSettings {

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'getFromRedisWFModule';
        reg.Caption = '@@Aus dem Cache lesen';
        reg.GroupID = 'wfStatus';
        reg.Index = 40;
        reg.SettingsControl = GetFromRedisSettings;
        reg.SettingsTypeHelper = new GetFromRedisSettingsDataHelper();
        reg.Executer = GetFromRedisModuleExecuter;
        return reg;
    }

    initialize(data: any) {
        if (data && data.Key) {
            if (data.Key) {
                this.ActualStatusKey = data.Key;
            }
        }
    }

    getResult(): any {
        const retVal = new GetFromRedisSettingsData();
        retVal.Key = this.ActualStatusKey;
        return retVal;
    }
}
